module.exports = __webpack_public_path__ + "img/banner1协会工作手机端.48bbb26d.jpg";